import { useMemo } from 'react';

import { ROLES } from '../../../_configuration';
import { getCurrMember } from './member.service';
import { getAssessments } from './assessment.service';
import { providedMemberHasRoleInAnyScope } from './user.service';

// Hook (wraps getCurrMember/getAssessments — a "hook in disguise"): mirrors the
// CONFIGURATION check RouteByRole runs. Returns `loading` to avoid a flash-redirect.
export const hasConfigurationAccess = (): { hasConfiguration: boolean; loading: boolean } => {
  const { member, loading: memberLoading } = getCurrMember();
  const { assessments, loading: assessmentsLoading } = getAssessments();

  // `loading` stays true only while initial data is missing, so a warm-cache refetch
  // doesn't flash a spinner / flash-redirect (both start empty under cache-and-network).

  // eslint-disable-next-line react-hooks/rules-of-hooks
  return useMemo(() => ({
    hasConfiguration: providedMemberHasRoleInAnyScope({ member, assessments, roles: [ROLES.CONFIGURATION] }),
    loading: (memberLoading && !member) || (assessmentsLoading && !assessments.length),
  }), [member, assessments, memberLoading, assessmentsLoading]);
};
